import { DuckSelector, objectDuckCreator } from '@atc/modular-redux';

const activeInteractionDuck = objectDuckCreator({
    store: 'activeInteraction',
    initialState: {
        isOneClickOptedIn: false,
        isShoppingAssistant: false,
        showKeywordSearchModal: false,
    },
}).extend({
    selectors: {
        getIsShoppingAssistant: new DuckSelector((selectors) => (state) => selectors.getDuckState(state).isShoppingAssistant),
        getShowKeywordSearchModal: new DuckSelector((selectors) => (state) => selectors.getDuckState(state).showKeywordSearchModal),
        isOneClickOptedIn: new DuckSelector((selectors) => (state) => selectors.getDuckState(state).isOneClickOptedIn),
    },
});

export default activeInteractionDuck;
